import apiClient from "@/clients/apiClient";
import { ApiResponse } from "@/utils/ApiResponse";
import { EstadoInventarioInterface } from "../interfaces/estadoInventario.interface";


export async function getEstadoInventarioAction(): Promise<
  ApiResponse<EstadoInventarioInterface>
> {
  const { data } = await apiClient.get<EstadoInventarioInterface>("reports/inventario");

  return {
    status: 200,
    data,
    message: "Reporte de inventario obtenido correctamente",
  };
}